import React from "react";
import MedicalPageLayout from "../../components/medical/MedicalPageLayout";
import { MEDICAL_PAGES } from "../../data/medicalPagesContent";
import { Briefcase } from "lucide-react";
import HighlightedContactSection from "../../components/HighlightedContactSection";

export default function BesetztePositionenPage() {
  const page = MEDICAL_PAGES["besetzte-positionen"];
  const positions = page.positions || [];

  return (
    <MedicalPageLayout page={page}>
      {positions.length > 0 && (
        <div className="mt-12">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900 border-b border-neutral-200 pb-3 mb-8">
            Auszug besetzter Positionen der REPEXO medical
          </h2>
          <ul className="grid gap-3 sm:grid-cols-1 md:grid-cols-2">
            {positions.map((position, i) => (
              <li
                key={i}
                className="flex gap-3 rounded-lg border border-neutral-200/90 bg-white py-4 px-4 pr-5 shadow-sm transition-shadow hover:shadow-md"
              >
                <span className="mt-0.5 shrink-0 text-emerald-600" aria-hidden>
                  <Briefcase className="h-5 w-5" strokeWidth={2} />
                </span>
                <span className="text-[15px] leading-6 text-neutral-800">
                  {position}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="mt-12 w-full max-w-none">
        <HighlightedContactSection
          heading="Positionen wie diese besetzen?"
          description="Wir unterstützen Sie bei der Besetzung anspruchsvoller Positionen in der Gesundheitsbranche."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-besetzte-positionen-contact"
        />
      </div>
    </MedicalPageLayout>
  );
}
